var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.519,
    height: 32.528,
    viewBox: "0 0 26.519 32.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152669",
    "data-name": "Group 152669",
    transform: "translate(-2.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103498",
    "data-name": "Path 103498",
    d: "M21.622,0h.231A6.965,6.965,0,0,1,20.1,5.249,5.437,5.437,0,0,1,15.313,7.5,6.756,6.756,0,0,1,17.1,2.41,7.712,7.712,0,0,1,21.622,0Zm7,23.876v.064a18.925,18.925,0,0,1-2.708,5.221c-1.033,1.421-2.3,3.334-4.558,3.334-1.953,0-3.249-1.256-5.251-1.29-2.117-.034-3.281,1.05-5.216,1.323h-.66a5.894,5.894,0,0,1-3.4-2.345A20.548,20.548,0,0,1,2.1,18.361V16.906A9.533,9.533,0,0,1,6.266,9.081a7.029,7.029,0,0,1,4.719-1.093,11.872,11.872,0,0,1,2.312.663,6.385,6.385,0,0,0,2.311.693,5.548,5.548,0,0,0,1.621-.5,9.975,9.975,0,0,1,5.216-.926,7.237,7.237,0,0,1,5.318,3.171,6.824,6.824,0,0,0-3.467,6.77A6.989,6.989,0,0,0,28.623,23.876Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplestore);
export default __webpack_public_path__ + "static/media/applestore.da63ad55b02ad12579b0e76d99d5a66a.svg";
export { ForwardRef as ReactComponent };